import { Map, YMaps } from '@pbe/react-yandex-maps';
import React, { memo, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Context } from '../..';
import { fetchReverseGeocode } from '../../http/basketApi';
import ButtonUI from '../UI/ButtonUI/ButtonUI';
import MapControls from '../UI/MapControls/MapControls';
import useMapControl from './hooks/useMapControl';
import PlacemarkIcon from './icons/pin.svg';


const COORDINATE_THRESHOLD = 0.0001;

function DeliveryMap({
  handleSelectAddress
}) {
  const {delivery} = useContext(Context)
  const mapRef = useRef(null);
  const {handleLocateMe, handleZoomIn, handleZoomOut} = useMapControl(mapRef)
  const [centerCoords, setCenterCoords] = useState(delivery.cityInfo ? [delivery.cityInfo.data.geo_lat, delivery.cityInfo.data.geo_lon] : [55.75, 37.62]);
  const [selectedCoords, setSelectedCoords] = useState(delivery.cityInfo ? [delivery.cityInfo.data.geo_lat, delivery.cityInfo.data.geo_lon] : [55.75, 37.62]);
  const [tempCoords, setTempCoords] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const prevCoordsRef = useRef(selectedCoords);

  const updateCenter = useCallback(() => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      setCenterCoords(newCenter);
    }
  }, []);

  const handleActionEnd = useCallback(() => {
    if (mapRef.current) {
      const currentCenter = mapRef.current.getCenter();
      const prevCoords = prevCoordsRef.current;
      
      const latDiff = Math.abs(currentCenter[0] - prevCoords[0]);
      const lngDiff = Math.abs(currentCenter[1] - prevCoords[1]);
      
      if (latDiff > COORDINATE_THRESHOLD || lngDiff > COORDINATE_THRESHOLD) {
        setTempCoords(currentCenter);
        setShowConfirm(true);
      } else {
        setShowConfirm(false);
      }
    }
  }, []);

  useEffect(() => {
    prevCoordsRef.current = selectedCoords;
  }, [selectedCoords]);

  const handleConfirm = useCallback(async () => {
    if (tempCoords) {
      setSelectedCoords(tempCoords);
      setShowConfirm(false);

      const coords = centerCoords;

      try {
        const response = await fetchReverseGeocode({ lat: String(coords[0]), lon: String(coords[1])})

        if(response.suggestions[0]){
           if(
               delivery.cityInfo.data.city == response.suggestions[0].data.city
               || delivery.cityInfo.data.region == response.suggestions[0].data.region
           ){
             delivery.setSearchAddress(response.suggestions[0] ?? null);
             delivery.setError("");
             delivery.setHasError(false);
             handleSelectAddress()
           } else {
             delivery.setError("К сожалению, доставка по этому адресу недоступна. Пожалуйста, выберите другой адрес.");
             delivery.setHasError(true);
           }
        }

      } catch (error) {
        console.error('fetchReverseGeocode error: ', error);
      }
    }
  }, [tempCoords]);

  return (
    <YMaps>
      <div className='shipping-map' style={{ position: 'relative', width: '100%', height: '100%' }}>
        <Map
          defaultState={{ center: centerCoords, zoom: 10, controls: [] }}
          instanceRef={mapRef}
          onBoundsChange={updateCenter}
          onActionEnd={handleActionEnd}
          style={{ width: '100%', height: '100%' }}
        />
        
        <img 
          src={PlacemarkIcon} 
          alt="marker"
          style={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            width: 55,
            pointerEvents: 'none',
            zIndex: 100
          }} 
        />

        {showConfirm && (
          <div className='shipping-map__confirm'>
            <ButtonUI 
              className="shipping-map__confirm-button"
              onClick={handleConfirm}
              text="Подтвердить"
            />
          </div>
        )}

        <MapControls 
          className="shipping-map__controls" 
          onLocate={handleLocateMe} 
          onZoomIn={handleZoomIn} 
          onZoomOut={handleZoomOut} 
        />
      </div>
    </YMaps>
  );
}

export default memo(DeliveryMap);